import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionConfig } from '../types';

export const CREATE_LEVEL_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: false,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

const EDIT_LEVEL_PERMISSIONS: PermissionConfig = CREATE_LEVEL_PERMISSIONS;

export const LevelPermissionManager =
  PermissionManagerFactory.create({
    permissionConfigForCreate: CREATE_LEVEL_PERMISSIONS,
    permissionConfigForEdit: EDIT_LEVEL_PERMISSIONS,
    permissionConfigForDelete: null,
  });
